<script>
import BaseView from "@/views/BaseView.vue";
import DatePicker from "@/components/pickers/DatePicker.vue";
import TimePicker from "@/components/pickers/TimePicker.vue";
import TableFilter from "@/components/tableFilter/TableFilter.vue";
import TableFilterRow from "@/components/tableFilter/TableFilterRow.vue";
import { mapActions, mapState } from "pinia";
import { useAppStore } from "@/store/app.store";
import SearchField from "@/components/inputs/SearchField.vue";
import { useSnackbarStore } from "@/store/snackbar.store";
import { useDateTime } from "@/composables/index.ts";

const { dateToUTC, systemDateTimeFormat } = useDateTime();

export default {
  name: "TrucksHistorySearch",
  components: { SearchField, TableFilterRow, TableFilter, TimePicker, DatePicker },
  mixins: [BaseView],
  emits: ["search"],
  data() {
    return {
      params: { number: "", dateFrom: this.$dayjs().format(), dateTo: this.$dayjs().add(1, "days").format() },
      today: this.$dayjs().format("YYYY-MM-DD"),
    };
  },
  computed: {
    ...mapState(useAppStore, ["dispatcher"]),
  },
  watch: {
    dispatcher: {
      handler(value) {
        if (!value) {
          return;
        }

        this.getTruckFromQuery();
      },
    },
  },
  methods: {
    ...mapActions(useSnackbarStore, ["showSnackbarError"]),
    clear() {
      this.params = {
        number: "",
        dateFrom: this.$dayjs().format(),
        dateTo: this.$dayjs().add(1, "days").format(),
        timeFrom: "",
        timeTo: "",
      };
      this.search();
    },
    search() {
      const dtFrom = dateToUTC(
        this.params.dateFrom + (this.params.timeFrom ? `T${this.params.timeFrom}` : ""),
        this.dispatcher.timezone,
      );
      const dtTo = dateToUTC(
        this.params.dateTo + (this.params.timeTo ? `T${this.params.timeTo}` : ""),
        this.dispatcher.timezone,
      );

      if (dtTo.diff(dtFrom, "days") > 4) {
        this.showSnackbarError("Date range should not exceed 4 days");
        this.params.dateTo = this.$dayjs(this.params.dateFrom).add(4, "days").format();
        return;
      }

      const params = {
        number: this.params.number,
        dateFrom: dtFrom.format(systemDateTimeFormat),
        dateTo: dtTo.format(systemDateTimeFormat),
      };

      this.$emit("search", params);
    },
    async getTruckFromQuery() {
      const truckNumberFromQuery = this.$route?.query?.truckNumber;

      if (truckNumberFromQuery) {
        this.params.number = truckNumberFromQuery;
        await this.$nextTick();
        this.$refs.truckNumber?.search();
      }
    },
  },
};
</script>

<template>
  <table-filter :expandable="false" :filters="params" @apply="search" @clear="clear">
    <template #header>
      <table-filter-row :divider="false" :label="$t('general.filter-main')" icon="mdi-filter-variant">
        <v-col cols="2">
          <search-field
            ref="truckNumber"
            v-model="params.number"
            data-qa="number"
            label="Truck number"
            @search="search"
          />
        </v-col>
        <v-col cols="2">
          <date-picker v-model="params.dateFrom" :label="'Date from'" @search="search" />
        </v-col>
        <v-col cols="2">
          <time-picker v-model="params.timeFrom" :label="'Time from'" @search="search" />
        </v-col>
        <v-col cols="2">
          <date-picker v-model="params.dateTo" :label="'Date to'" @search="search" />
        </v-col>
        <v-col cols="2">
          <time-picker v-model="params.timeTo" :label="'Time to'" @search="search" />
        </v-col>
      </table-filter-row>
    </template>
  </table-filter>
</template>
